import React, { Component } from 'react'
import {
    Form,
    Card,
    Row,
    Col,
    InputNumber,
    Tag,
    Divider,
    Switch,
    Select,
    message
} from 'antd'
import { CirclePicker } from 'react-color'
import styled from 'styled-components'
import { ShoppingCartOutlined } from '@ant-design/icons'
import { getAppConfig, setAppConfig } from '../../../services/apiServices'
import RowLayout from '../../../commons/RowLayout/RowLayout'
import LoadingModal from '../../../commons/Modal/Loading'
import SaveButton from '../../../commons/Button/SaveButton'
import ColorSelector from '../../../commons/ColorSelector/ColorSelector'

const { Option } = Select

const COLOR_LIST = [
    '#e74c3c',
    '#e91e63',
    '#9c27b0',
    '#673ab7',
    '#3f51b5',
    '#2196f3',
    '#03a9f4',
    '#00bcd4',
    '#009688',
    '#4caf50',
    '#8bc34a',
    '#cddc39',
    '#ffeb3b',
    '#ffcc00',
    '#ff9800',
    '#ff5722',
    '#795548',
    '#2c3e50'
]

const SOCIAL_SHARE_APPS = [
    { key: 'pinterest', name: 'Pinterest' },
    { key: 'facebook', name: 'Facebook' },
    { key: 'twitter', name: 'X (Twitter)' },
    { key: 'line', name: 'Line' },
    { key: 'linkedin', name: 'LinkedIn' },
    { key: 'tumblr', name: 'Tumblr' }
]

const Container = styled(Card)`
    .image-wrapper {
        display: inline-block;
        padding: 20px;
        margin-top: 15px;
        border: 1px dashed #ccc;
        > img {
            max-width: 400px;
        }
    }
    .header-image-wrapper {
        cursor: pointer;
        display: flex;
        max-width: 500px;
        margin-bottom: 15px;
        &:hover {
            opacity: 0.8;
        }
        &.selected {
            border: 3px solid #1890ff !important;
        }

        img {
            width: 100%;
        }
    }
    .radio-y {
        display: block;
        height: 30px;
        line-height: 30px;
    }
`

const PRODUCT_IMAGE_STYLES = [
    { id: 1 },
    { id: 2 },
    { id: 3 },
    { id: 4 },
    { id: 5 }
]

const PRODUCT_DETAIL_STYLES = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }]

class ProductGeneral extends Component {
    state = {
        isLoading: false,
        singleProductImageStyle: 1,
        singleProductDetailStyle: 1,
        starColor: ''
    }

    formRef = React.createRef()

    componentDidMount() {
        this.getConfig()
    }

    onFinish(values) {
        let data = {
            single_product_image_style: this.state.singleProductImageStyle,
            single_product_detail_style: this.state.singleProductDetailStyle,
            star_color: this.state.starColor,
            enable_shop_sidebar: values.enableShopSidebar,
            enable_shop_toolbar: values.enableShopToolbar,
            enable_shop_product_card_border: values.enableShopProductCardBorder,
            enable_single_product_related: values.enableSingleProductRelated,
            products_per_page: values.productsPerPage,
            products_per_row: {
                xs: values.productsPerRowXs,
                md: values.productsPerRowMd,
                lg: values.productsPerRowLg
            },
            single_product_share_apps: values.singleProductShareApps
        }
        this.setConfig(data)
    }

    async getConfig() {
        this.setState({ isLoading: true })
        try {
            let config = await getAppConfig()
            this.setState({
                isLoading: false,
                singleProductImageStyle: config.single_product_image_style,
                singleProductDetailStyle: config.single_product_detail_style,
                starColor: config.star_color
            })

            this.formRef.current &&
                this.formRef.current.setFieldsValue({
                    enableShopSidebar: !!config.enable_shop_sidebar,
                    enableShopToolbar: !!config.enable_shop_toolbar,
                    enableShopProductCardBorder:
                        !!config.enable_shop_product_card_border,
                    enableSingleProductRelated:
                        !!config.enable_single_product_related,
                    productsPerPage: config.products_per_page,
                    productsPerRowXs: config.products_per_row?.xs || 3,
                    productsPerRowMd: config.products_per_row?.md || 2,
                    productsPerRowLg: config.products_per_row?.lg || 2,
                    singleProductShareApps:
                        config.single_product_share_apps || []
                })
        } catch (error) {
            console.log(error)
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    async setConfig(data) {
        this.setState({ isLoading: true })
        try {
            await setAppConfig({
                body: { config: data }
            })
            this.setState({
                isLoading: false
            })
            message.success(this.props.T('SAVED'))
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    onChangeSingleProductImageStyle(style) {
        this.setState({ singleProductImageStyle: style })
    }

    onChangeSingleProductDetailStyle(style) {
        this.setState({ singleProductDetailStyle: style })
    }

    onChangeColor = color => {
        this.setState({ starColor: color })
    }

    render() {
        let { T } = this.props

        return (
            <Form ref={this.formRef} onFinish={this.onFinish.bind(this)}>
                <Container
                    title={
                        <span className="text-xl">
                            <ShoppingCartOutlined /> {T('PRODUCT')} -{' '}
                            {T('GENERAL')}
                        </span>
                    }>
                    <RowLayout title={T('RATING_STARS_COLOR')}>
                        <div style={{ marginBottom: 15 }}>
                            <CirclePicker
                                width={400}
                                color={this.state.starColor}
                                colors={COLOR_LIST}
                                onChange={color =>
                                    this.onChangeColor(color.hex)
                                }
                            />
                        </div>
                        <div>
                            <div style={{ marginBottom: 10 }}>{T('OR')}</div>
                            <ColorSelector
                                disableRemoveIcon
                                color={this.state.starColor}
                                onChange={this.onChangeColor.bind(this)}
                            />
                        </div>
                    </RowLayout>

                    <Divider orientation="left">{T('CATEGORY_PAGE')}</Divider>

                    <RowLayout title={T('ENABLE_SIDEBAR')}>
                        <Form.Item
                            name="enableShopSidebar"
                            valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </RowLayout>

                    <RowLayout title={T('ENABLE_TOOLBAR')}>
                        <Form.Item
                            name="enableShopToolbar"
                            valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </RowLayout>

                    <RowLayout title={T('ENABLE_PRODUCT_CARD_BORDER')}>
                        <Form.Item
                            name="enableShopProductCardBorder"
                            valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </RowLayout>

                    <RowLayout title={T('NUMBER_POSTS_TOTAL')}>
                        <Form.Item
                            name="productsPerPage"
                            rules={[
                                {
                                    required: true,
                                    message: T('FORM_ERR_REQUIRE')
                                }
                            ]}>
                            <InputNumber min={1} />
                        </Form.Item>
                    </RowLayout>

                    <RowLayout title={T('NUMBER_POSTS_ROW')}>
                        <div
                            style={{ display: 'flex', alignItems: 'baseline' }}>
                            <Form.Item
                                name="productsPerRowLg"
                                rules={[
                                    {
                                        required: true,
                                        message: T('FORM_ERR_REQUIRE')
                                    }
                                ]}>
                                <InputNumber
                                    min={1}
                                    max={12}
                                    style={{
                                        display: 'inline-block',
                                        marginRight: 10
                                    }}
                                />
                            </Form.Item>
                            <span>
                                <Tag color="magenta">{T('ON_DESKTOP')}</Tag>
                            </span>
                        </div>
                        <div
                            style={{ display: 'flex', alignItems: 'baseline' }}>
                            <Form.Item
                                name="productsPerRowMd"
                                rules={[
                                    {
                                        required: true,
                                        message: T('FORM_ERR_REQUIRE')
                                    }
                                ]}>
                                <InputNumber
                                    min={1}
                                    max={12}
                                    style={{
                                        display: 'inline-block',
                                        marginRight: 10
                                    }}
                                />
                            </Form.Item>
                            <span>
                                <Tag color="orange">{T('ON_TABLET')}</Tag>
                            </span>
                        </div>
                        <div
                            style={{ display: 'flex', alignItems: 'baseline' }}>
                            <Form.Item
                                name="productsPerRowXs"
                                rules={[
                                    {
                                        required: true,
                                        message: T('FORM_ERR_REQUIRE')
                                    }
                                ]}>
                                <InputNumber
                                    min={1}
                                    max={12}
                                    style={{
                                        display: 'inline-block',
                                        marginRight: 10
                                    }}
                                />
                            </Form.Item>
                            <span>
                                <Tag color="green">{T('ON_MOBILE')}</Tag>
                            </span>
                        </div>
                    </RowLayout>

                    <Divider orientation="left">{T('PRODUCT_PAGE')}</Divider>

                    <RowLayout title={T('PRODUCT_IMAGE_STYLE')}>
                        <Form.Item>
                            <Row gutter={16}>
                                {PRODUCT_IMAGE_STYLES.map(style => (
                                    <Col span={4} key={style.id}>
                                        <div
                                            className={`header-image-wrapper ${
                                                style.id ==
                                                this.state
                                                    .singleProductImageStyle
                                                    ? 'selected'
                                                    : ''
                                            }`}
                                            style={{
                                                border: '2px solid #ddd'
                                            }}
                                            onClick={() =>
                                                this.onChangeSingleProductImageStyle(
                                                    style.id
                                                )
                                            }>
                                            <img
                                                src={`${window.config.themeUrl}/manager/static/images/layout-single-product-image/${style.id}.jpg`}
                                            />
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Form.Item>
                    </RowLayout>

                    <RowLayout title={T('PRODUCT_CONTENT_STYLE')}>
                        <Form.Item>
                            <Row gutter={16}>
                                {PRODUCT_DETAIL_STYLES.map(style => (
                                    <Col span={4} key={style.id}>
                                        <div
                                            className={`header-image-wrapper ${
                                                style.id ==
                                                this.state
                                                    .singleProductDetailStyle
                                                    ? 'selected'
                                                    : ''
                                            }`}
                                            style={{
                                                border: '2px solid #ddd'
                                            }}
                                            key={style.id}
                                            onClick={() =>
                                                this.onChangeSingleProductDetailStyle(
                                                    style.id
                                                )
                                            }>
                                            <img
                                                src={`${window.config.themeUrl}/manager/static/images/layout-single-product-content/${style.id}.jpg`}
                                            />
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Form.Item>
                    </RowLayout>

                    <RowLayout title={T('ENABLE_RELATED_PRODUCTS')}>
                        <Form.Item
                            name="enableSingleProductRelated"
                            valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </RowLayout>

                    <RowLayout title={T('SHARING_CHANNEL')}>
                        <Form.Item name="singleProductShareApps">
                            <Select
                                mode="multiple"
                                placeholder={T('SELECT_CHANNELS')}
                                optionLabelProp="label">
                                {SOCIAL_SHARE_APPS.map(app => (
                                    <Option
                                        key={app.key}
                                        value={app.key}
                                        label={app.name}>
                                        {app.name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </RowLayout>

                    <LoadingModal isOpen={this.state.isLoading} />
                </Container>
                <SaveButton T={T} />
            </Form>
        )
    }
}

export default ProductGeneral
